/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Open_Full_VaultInputs */

const en_open_full_vault = /** @type {(inputs: Open_Full_VaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open Full Vault Console`)
};

const id_open_full_vault = /** @type {(inputs: Open_Full_VaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buka Konsol Vault Penuh`)
};

/** @type {(inputs: Open_Full_VaultInputs) => LocalizedString} */
const es_open_full_vault = en_open_full_vault;

/** @type {(inputs: Open_Full_VaultInputs) => LocalizedString} */
const fr_open_full_vault = en_open_full_vault;

/** @type {(inputs: Open_Full_VaultInputs) => LocalizedString} */
const de_open_full_vault = en_open_full_vault;

/** @type {(inputs: Open_Full_VaultInputs) => LocalizedString} */
const ja_open_full_vault = en_open_full_vault;

/** @type {(inputs: Open_Full_VaultInputs) => LocalizedString} */
const zh_open_full_vault = en_open_full_vault;

/** @type {(inputs: Open_Full_VaultInputs) => LocalizedString} */
const ar_open_full_vault = en_open_full_vault;

/** @type {(inputs: Open_Full_VaultInputs) => LocalizedString} */
const it_open_full_vault = en_open_full_vault;

/** @type {(inputs: Open_Full_VaultInputs) => LocalizedString} */
const ru_open_full_vault = en_open_full_vault;

/** @type {(inputs: Open_Full_VaultInputs) => LocalizedString} */
const pt_open_full_vault = en_open_full_vault;

/** @type {(inputs: Open_Full_VaultInputs) => LocalizedString} */
const ko_open_full_vault = en_open_full_vault;

/**
* | output |
* | --- |
* | "Open Full Vault Console" |
*
* @param {Open_Full_VaultInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const open_full_vault = /** @type {((inputs?: Open_Full_VaultInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Open_Full_VaultInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_open_full_vault(inputs)
	if (locale === "es") return es_open_full_vault(inputs)
	if (locale === "fr") return fr_open_full_vault(inputs)
	if (locale === "de") return de_open_full_vault(inputs)
	if (locale === "ja") return ja_open_full_vault(inputs)
	if (locale === "zh") return zh_open_full_vault(inputs)
	if (locale === "ar") return ar_open_full_vault(inputs)
	if (locale === "id") return id_open_full_vault(inputs)
	if (locale === "it") return it_open_full_vault(inputs)
	if (locale === "ru") return ru_open_full_vault(inputs)
	if (locale === "pt") return pt_open_full_vault(inputs)
	return ko_open_full_vault(inputs)
});